import { render, staticRenderFns } from "./compRegMobile.vue?vue&type=template&id=144ff9c0&scoped=true"
import script from "./compRegMobile.vue?vue&type=script&lang=js"
export * from "./compRegMobile.vue?vue&type=script&lang=js"
import style0 from "./compRegMobile.vue?vue&type=style&index=0&id=144ff9c0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144ff9c0",
  null
  
)

export default component.exports